import { STRING_CONSTANTS } from "./constants/stringConstants";

// Where a signed-in user belongs. Subscribers to any product go to the product
// picker (which launches straight into Invoice Chaser etc); everyone else gets the
// jobs Home. Used right after a password login AND when someone who is already
// signed in opens /signin or the bare domain, so a subscriber never lands on the
// jobs page just because their cookie was still valid.
export function getPostLoginDestination(user: any): string {
    const products: string[] = [];
    if (user?.isAccountsSignup) products.push('/ar');
    if (user?.isInterviewSimulatorSignup) products.push('/interview-simulator/dashboard');
    if (user?.isLegalAssistSignup) products.push('https://simulation.mploi.com/legal');
    if (user?.isHrSimulatorSignup) products.push('https://simulation.mploi.com/hr');
    if (user?.isArAffiliateSignup) products.push('/ar/affiliate/dashboard');
    if (user?.isRentChaserSignup) products.push('https://rentchaser.mploi.com');
    if (products.length >= 1) return '/app-selector';
    return STRING_CONSTANTS.navigationString.index;
}
